import { Badge, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTableTranslation } from '@hero/molecules';

import * as S from './style';

function SecondHead({ globalFilters, onFilterChange }) {
  const translation = useTableTranslation();
  const { t } = useTranslation();

  return (
    (!!globalFilters?.filters?.role.length || !!globalFilters?.filters?.status.length) && (
      <S.SubtitleWrapper>
        <Typography variant="caption1">{`${t(translation.filteredWithText)}:`}</Typography>
        {globalFilters.filters?.role.map(filter => (
          <Badge
            color="bgDefault"
            variant="contained"
            key={filter.value}
            size="sm"
            rounded
            closable
            onClose={() => {
              onFilterChange({
                status: globalFilters.filters.status,
                role: globalFilters.filters.role.filter(f => f.value !== filter.value)
              });
            }}
          >
            {filter.label}
          </Badge>
        ))}
        {globalFilters.filters?.status.map(filter => (
          <Badge
            color="bgDefault"
            variant="contained"
            key={filter.value}
            size="sm"
            rounded
            closable
            onClose={() => {
              onFilterChange({
                status: globalFilters.filters.status.filter(f => f.value !== filter.value),
                role: globalFilters.filters.role
              });
            }}
          >
            {filter.label}
          </Badge>
        ))}
      </S.SubtitleWrapper>
    )
  );
}

SecondHead.propTypes = {
  globalFilters: PropTypes.shape({
    filters: PropTypes.shape({
      role: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      status: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    })
  }),
  onFilterChange: PropTypes.func
};

export { SecondHead };
